module.exports = __webpack_public_path__ + "img/skeleton.f5b286fd.png";